<patient-ui-orbi-live-region></patient-ui-orbi-live-region>

<!-- Orbi AI chat panel (PCSA-13158): off-canvas overlay (outside content flow).
     The panel body shows EITHER the message thread (PCSA-13160) or the
     conversation-history view (PCSA-13169); the header history icon toggles the
     history view (no back arrow, per design), and a resumed conversation
     returns to the thread. Both are only instantiated while the panel is open.

     This component carries NOTHING but the panel, so a layout can mount it
     anywhere outside its `.main-content-wrapper` — the overlay must not be inside
     the content flow it covers. -->
<patient-ui-orbi-panel
  *ngIf="orbiAgentAvailable$ | async"
  [open]="(orbiPanelOpen$ | async) ?? false"
  [historyActive]="orbiHistoryOpen"
  [locked]="(orbiChatLocked$ | async) ?? false"
  (newConversation)="newOrbiConversation()"
  (history)="toggleOrbiHistory()"
  (closed)="closeOrbiPanel()"
>
  <ng-container *ngIf="(orbiPanelOpen$ | async) ?? false">
    <patient-ui-orbi-history-list
      *ngIf="orbiHistoryOpen; else orbiThreadView"
      [sessionLocked]="(orbiChatLocked$ | async) ?? false"
      (resumed)="closeOrbiHistory()"
    ></patient-ui-orbi-history-list>
    <ng-template #orbiThreadView>
      <patient-ui-orbi-thread></patient-ui-orbi-thread>
    </ng-template>
  </ng-container>
</patient-ui-orbi-panel>
